module.exports = __webpack_public_path__ + "img/WiiGay.a509d24d.jpg";